export default __webpack_public_path__ + "static/media/cha_healer_folinic.7e4d698c.png";